
import { Title, Meta } from "react-head";

function SEOManager() {
  return (
    <>
      <Title>GP PonBhoomi: Residential Plots, Land for Sale, Price start from ₹13L to ₹30L</Title>
      <Meta
        name="description"
        content="GP Homes PonBhoomi offers CMDA-approved premium residential villa plots from ₹13.5L & Luxury Villas from ₹30L. Invest in your dream property with GP Homes today!"
      />
    </>
  );
}

export default SEOManager;